import React from 'react'
import Button, { buttonClasses } from '@mui/material/Button'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Popper from '@mui/material/Popper'
import { Grow } from '@mui/material'
import Paper from '@mui/material/Paper'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import CheckIcon from '@mui/icons-material/Check'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  filterBtn: {
    [`&.${buttonClasses.root}`]: {
      justifyContent: 'space-between',
      height: '38px',
      borderColor: '#ccc',
      paddingLeft: '20px',
    },
  },
}))

const PAGINATE_BY_OPTIONS = [10, 25, 50]

interface Props {
  paginateBy: number
  compact?: boolean
  shortLabel?: boolean

  setPaginateBy(paginateBy: number): void
}

const PaginateByButton: React.FC<Props> = ({ paginateBy, setPaginateBy, compact, shortLabel }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const anchorPaginateByBtn = React.useRef<HTMLButtonElement>(null)
  const [isOpenPaginateByMenu, setIsOpenPaginateByMenu] = React.useState(false)

  const handleClickPaginateBy = (val: number) => {
    setIsOpenPaginateByMenu(false)
    setPaginateBy(val)
  }

  return (
    <div
      className={compact ? 'relative' : 'flex justify-end w-full relative pr-10 pb-10'}
      onClick={e => e.stopPropagation()}
    >
      <Button
        ref={anchorPaginateByBtn}
        variant='outlined'
        className={classes.filterBtn}
        endIcon={isOpenPaginateByMenu ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        size='small'
        onClick={() => setIsOpenPaginateByMenu(true)}
        disableElevation
        disableFocusRipple
        disableRipple
      >
        <span className='normal-case leading-5 font-bold text-13 whitespace-nowrap'>
          <strong>{shortLabel ? paginateBy : `${t('button.itemsPerPage', 'Items per page')}: ${paginateBy}`}</strong>
        </span>
      </Button>
      <Popper
        open={isOpenPaginateByMenu}
        anchorEl={anchorPaginateByBtn.current}
        className='z-10'
        style={{ width: 168 }}
        role={undefined}
        placement='bottom-start'
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setIsOpenPaginateByMenu(false)}>
                <MenuList autoFocusItem={isOpenPaginateByMenu}>
                  {PAGINATE_BY_OPTIONS.map(val => (
                    <MenuItem key={val} onClick={() => handleClickPaginateBy(val)}>
                      <span className='flex-1'>{val}</span>
                      {paginateBy === val && <CheckIcon />}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default PaginateByButton
